import React from "react"
import PropTypes from "prop-types"
import lottie from 'lottie-web';

class PurchaseSuccess extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show: true,
      id: ''
    }

    this.loadLottie = this.loadLottie.bind(this)
  }

  loadLottie() {
    lottie.loadAnimation({
      container: document.getElementById('badgeAlert'),
      renderer: 'svg',
      name: 'badgeAlert',
      loop: false,
      autoplay: true,
      speed: .1,
      path: this.props.confettiLottie
    });
  }

  componentDidMount() {
    this.setState({
      show: true,
    })
    this.loadLottie()
  }


  render() {

      return(
            <div style={{marginTop: 20}}>
              <div style={{justifyContent: 'center', height: 500, marginTop: -250}} id="badgeAlert">
              </div>
            </div>
      )

  }
}


export default PurchaseSuccess
